<template>
  <div class="min-h-screen flex items-center justify-center text-white p-6">
    <div class="max-w-lg w-full bg-[var(--color-surface)] border border-[var(--color-border)] rounded shadow-lg p-6">
      <div class="flex items-center justify-between mb-4">
        <div>
          <div class="text-lg font-semibold">{{ $t('tenantOidc.signInTo', { tenant: tenantName || tenantSlug }) }}</div>
          <div class="text-sm text-gray-400">{{ $t('tenantOidc.selectProvider', { slug: tenantSlug }) }}</div>
        </div>
        <div>
          <button class="btn" @click="$router.push('/tenant')">{{ $t('tenantOidc.back') }}</button>
        </div>
      </div>

      <div v-if="loading" class="text-sm text-gray-400">{{ $t('tenantOidc.loadingProviders') }}</div>

      <div v-else>
        <div v-if="providers.length === 0" class="text-sm text-gray-400">{{ $t('tenantOidc.noProviders') }}</div>

        <div class="mt-4 grid gap-3">
          <button v-for="p in providers" :key="p.id" class="btn primary w-full flex items-center justify-between" @click="startOidc(p.id)">
            <div class="text-left">
              <div class="font-medium">{{ p.name }}</div>
              <div class="text-xs text-gray-300">{{ p.description || p.name }}</div>
            </div>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="M12 5l7 7-7 7"/></svg>
          </button>
        </div>

        <div v-if="error" class="mt-4 text-sm text-red-400">{{ error }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { getTenantOidc, authOidcAuthorize } from '../api/api.js'

export default {
  name: 'TenantOidcView',
  setup() {
    const route = useRoute()
    const { t } = useI18n()
    const tenantSlug = ref(route.query?.tenant || '')
    const providers = ref([])
    const tenantName = ref('')
    const loading = ref(true)
    const error = ref(null)

    async function load() {
      loading.value = true
      error.value = null
      try {
        const res = await getTenantOidc(tenantSlug.value)
        providers.value = res.oidc_providers || []
        tenantName.value = res.tenant?.name || ''
      } catch (e) {
        error.value = t('tenantOidc.loadFailed')
      } finally {
        loading.value = false
      }
    }

    async function startOidc(providerId) {
      try {
        const resp = await authOidcAuthorize(tenantSlug.value, providerId)
        if (resp?.authorization_url) window.location.href = resp.authorization_url
      } catch (e) {
        error.value = t('tenantOidc.startFailed')
      }
    }

    onMounted(load)

    return { tenantSlug, providers, loading, error, startOidc, tenantName, t }
  }
}
</script>
